import BbProxy from "@/proxies/BbProxy";

class DemoApprovedProxy extends BbProxy {
  constructor() {
    super("app/creative/demos/approved");
  }
}

export default DemoApprovedProxy;
